import React from 'react'
import {useTranslation} from "react-i18next";
import {Fab, Tooltip} from '@mui/material';
import ShoppingCartOutlinedIcon from '@mui/icons-material/ShoppingCartOutlined';
import ArrowForward from '@mui/icons-material/ArrowForward';

import {useCartContext} from '../../context/CartContext';
import routes from "../../common/constants/routes";
import {getRouteUrl} from "../../utility/navigationUtil";
import CCOLink from "./CCOLink";
import {usePageContext} from "../../context/PageContext";

export const INITIAL_OFFSET_CART = 140;
export const ADDITIONAL_OFFSET_LARGE_SCREEN = 65;

function CCOCartFab() {
    const pageContext = usePageContext();
    const cartLink = getRouteUrl(pageContext.rootUrl, routes.PUBLICATIONS.CART)
    const {totalAmountOfCartItems} = useCartContext();
    const {t} = useTranslation()

    const cartStyle = {
        alignItems: 'center',
        display: 'flex',
        height: '38px',
        justifyContent: 'space-between',
        lineHeight: '1',
        padding: '0 6px 0 11px',
        position: 'absolute',
        width: '70px',
    };

    const counterStyle = {
        alignItems: 'center',
        backgroundColor: 'primary.contrastText',
        border: '2px solid',
        borderColor: 'primary.main',
        borderRadius: '10px',
        color: 'primary.main',
        display: 'flex',
        fontFamily: '"HelveticaNeueLTStd-Bd", Helvetica, Arial, sans-serif',
        height: '20px',
        justifyContent: 'center',
        position: 'relative',
        right: '38px',
        textAlign: 'center',
        top: '-19px',
        transition: 'right .3s ease-out',
        width: '30px',
    }

    const fabStyle = {
        borderRadius: '3px 0 0 3px',
        boxShadow: '0 2px 5px 0 rgba(0,0,0,.15)',
        height: '38px',
        position: 'fixed',
        right: '-27px',
        top: {
            xs: INITIAL_OFFSET_CART,
            lg: INITIAL_OFFSET_CART + ADDITIONAL_OFFSET_LARGE_SCREEN
        },
        transition: 'right .3s ease-out',
        width: '72px',
        '#counter': counterStyle,
        '#cart': cartStyle,
        '&:hover': {
            right: 0,
            '#counter': {
                borderColor: 'primary.dark',
                color: 'primary.dark',
            }
        },
    };

    const amountDisplay = totalAmountOfCartItems < 100 ? totalAmountOfCartItems : '99+';

    return (
        <Tooltip title={t("cart.go_to_cart")}>
            <React.Fragment>
                <CCOLink target={cartLink}>
                    <Fab color='primary' aria-label='Warenkorb' variant='extended' sx={fabStyle}>
                        <div data-cypress={'cartSideIcon'} id='cart'>
                            <ShoppingCartOutlinedIcon/>
                            <ArrowForward/>
                        </div>
                        <div id='counter'>{amountDisplay}</div>
                    </Fab>
                </CCOLink>
            </React.Fragment>
        </Tooltip>)
}

export default CCOCartFab